import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_SKILLS = 'SET_SKILLS';
export const SKILLS_FETCHING = 'SKILLS_FETCHING';
export const STOP_SKILLS_FETCHING = 'STOP_SKILLS_FETCHING';
export const SET_CURRENT_SKILL = 'SET_CURRENT_SKILL';

const data = {
  skills: [],
  defaultSkill: {},
  currentSkill: null,
  fetching: false,
  skillsTotal: 0,
  pageSizeDefault: undefined,
};

const actions = {
  async loadSkills({ commit }, payload = { onlyActive: false }) {
    const skills = await api.getAllRequestTypes(payload);
    commit(SET_SKILLS, { skills });
    return skills;
  },
  loadSkillsPagination({ commit }, { page, pageSize, moreData = false }) {
    commit(SKILLS_FETCHING);
    return api.getAllRequestTypesPagination(page, pageSize).then((res) => {
      commit(SET_SKILLS, {
        skills: res.requestTypes, total: res.totalCount, moreData, pageSizeDefault: res.pageSize,
      });
      return res;
    }).catch((err) => {
      commit(STOP_SKILLS_FETCHING);
      throw err;
    });
  },
  createSkill(_, skillParams) {
    delete skillParams.defaultType;
    return api.createRequestType(skillParams).then((res) => res);
  },
  updateSkill(_, skillParams) {
    return api.updateRequestType(skillParams).then((res) => res);
  },
  async loadSkill({ commit, state }, id) {
    const skill = state.skills.find((item) => item.id === id) || await api.getRequestType(id);
    commit(SET_CURRENT_SKILL, skill);
  },
  async loadDefaultSkill({ commit, state }) {
    const skill = state.skills.find((item) => item.defaultType);
    commit('SET_DEFAULT_SKILL', skill);
  },
  clearCurrentSkill({ commit }) {
    commit(SET_CURRENT_SKILL, null);
  },
  async deleteSkill({ commit, state }, id) {
    const result = await api.deleteRequestType({ id });
    if (result) {
      const skills = state.skills.filter((skill) => skill.id !== result.id);
      commit(SET_SKILLS, { skills, total: state.skillsTotal - 1 });
    }
    return result;
  },
};

const mutations = {
  SET_SKILLS(state, {
    skills, total, moreData, pageSizeDefault,
  }) {
    state.pageSizeDefault = pageSizeDefault || state.pageSizeDefault;
    if (moreData) {
      state.skills = state.skills.concat(skills);
    } else {
      state.skills = skills;
    }
    mutations.STOP_SKILLS_FETCHING(state);
    state.skillsTotal = total || state.skillsTotal;
  },
  SKILLS_FETCHING(state) {
    state.fetching = true;
  },
  STOP_SKILLS_FETCHING(state) {
    state.fetching = false;
  },
  SET_CURRENT_SKILL(state, value) {
    state.currentSkill = value;
  },
  SET_DEFAULT_SKILL(state, value) {
    state.defaultSkill = value;
  },
};

const store = {
  state: data,
  actions,
  mutations,
  namespaced: true,
};

export default store;
